import React from 'react';
import { Path, Svg } from 'react-native-svg';
import type { IconProps } from './types';

export const ActivityIcon: React.FC<IconProps> = ({
  size = 16,
  color = '#020202',
  ...props
}) => (
  <Svg
    width={size}
    height={size}
    viewBox="0 0 16 16"
    fill="none"
    {...props}
  >
    <Path d="M4 8.79999L10 0.799988L8.8 7.19999H12L6 15.2L7.2 8.79999H4Z" stroke={color} strokeWidth="1.5" strokeLinejoin="round" />
  </Svg>
);

ActivityIcon.displayName = 'ActivityIcon';
